<template>
	<!-- A screen of height while the cart or the order is loading, so the footer
	stays below the fold instead of jumping as the checkout fills in (GF-73). -->
	<div :class="{ 'min-h-screen': !cartInitialized || isCheckoutLoading }">
		<!-- Gated on "cart resolved", not on `basket`: the cart loads from
		localStorage after mount, and children mount before the layout, so
		Checkout's own onMounted used to run before a basket existed. `basket` is a
		bad gate — it returns to undefined on a completed order, an empty cart or a
		locale switch, which would unmount the checkout mid-flow. -->
		<Checkout v-if="cartInitialized" />
		<div v-else class="main-wrapper my-10 flex justify-center" role="status">
			<div class="flex flex-col items-center gap-3 pt-24">
				<span
					class="inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-current border-e-transparent text-gray-700 motion-reduce:animate-[spin_1.5s_linear_infinite]"
					aria-hidden="true"
				/>
				<span class="text-sm text-gray-700">{{ $t("checkout_loading") }}</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

const cartInitialized = useCartInitialized();
const { getIsLoading: isCheckoutLoading } = storeToRefs(useHelpersStore());
</script>
